export const containsTestString = (data: any) => {
  const forbiddenStrings = [/test/i, /тест/i]; // Регулярные выражения для поиска

  return Object.values(data).some(
    value => typeof value === 'string' && forbiddenStrings.some(regex => regex.test(value))
  );
};
